import { render } from "./WeaponSlot.vue?vue&type=template&id=5d1c0932&scoped=true"
import script from "./WeaponSlot.vue?vue&type=script&lang=js"
export * from "./WeaponSlot.vue?vue&type=script&lang=js"

import "./WeaponSlot.vue?vue&type=style&index=0&id=5d1c0932&scoped=true&lang=css"
import "./WeaponSlot.vue?vue&type=style&index=1&id=5d1c0932&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1c0932"]])

export default __exports__